import React, { useEffect, useState, useCallback } from "react";
import { supabase } from "../../supabase-client";
import { ArrowLeft, Check, CircleX, Plus, X } from "lucide-react";
import Enviarmail from "../enviarmail";
import { getEstadosxPerfil } from "../../utils/estados";

const CotizacionModal = ({ cotizacion, onClose }) => {
   const [filterEstado, setFilterEstado] = useState("todos");
   // const [logeado, setLogeado] = useState(false);
   // const [loadingAuth, setLoadingAuth] = useState(true);
   const [editRecord, setEditRecord] = useState({
      id: 0,
      titulo: "",
      detalle: "",
      usuario_id: 0,
      alto: 0,
      ancho: 0,
      profundidad: 0,
      precio: 0,
      porcentaje: 50,
      saldo: 0,
      estado: "pendiente",
   });
   const [userRecord, setUserRecord] = useState({
      email: "",
      nombre: "",
      documento: 1,
      celular: "",
      perfil: 18,
      id: 0,
   });

   const estados = getEstadosxPerfil("admin");

   const estadoTexts = {
      cotizado: "cotizada",
      aceptado: "aceptada",
      pagado: "pagada",
      procesando: "en proceso",
      enviado: "enviada",
      entregado: "entregada",
      terminado: "terminada",
      anulado: "anulada",
      cancelado: "cancelada",
   };

   // Busco el usuario que hizo la cotizacion
   const fetchUser = useCallback(async (id) => {
      console.log("fetchUser: ");
      // setLoadingAuth(true);

      try {
         const { data: users, error: fetchError } = await supabase
            .from("usuarios")
            .select("*")
            .eq("id", id)
            .single();

         if (fetchError) {
            console.error("Error fetching user:", fetchError);
            // setLogeado(false);
            return;
         }

         if (users) {
            // setLogeado(true);
            setUserRecord({
               email: users.email || "",
               nombre: users.nombre || "",
               celular: users.celular || "",
               documento: users.documento || 1,
               perfil: users.perfil || 18,
               id: users.id || 0,
            });
         } else {
            console.log('No user found with the provided ID');
            // setLogeado(false);
         }
      } catch (error) {
         console.error("Error in fetchUser:", error);
         // setLogeado(false);
      } finally {
         console.log('fetchUser: ', userRecord);
         // setLoadingAuth(false);
      }
   }, []);

   // Enhanced close handler wrapped in useCallback
   const handleClose = useCallback((e) => {
      if (e) {
         e.preventDefault();
         e.stopPropagation();
      }

      // Reset form
      setEditRecord({
         id: 0,
         titulo: "",
         detalle: "",
         usuario_id: 0,
         alto: 0,
         ancho: 0,
         profundidad: 0,
         precio: 0,
         porcentaje: 0,
         saldo: 0,
         estado: "Pendiente",
      });

      // Call parent close function
      if (onClose && typeof onClose === "function") {
         onClose();
      }
   }, [onClose]);

   // Initialize editRecord properly in useEffect
   useEffect(() => {
      if (cotizacion) {
         setEditRecord({
            id: cotizacion.id,
            usuario_id: cotizacion.usuario_id || 0,
            titulo: cotizacion.titulo || "",
            detalle: cotizacion.detalle || "",
            alto: cotizacion.alto || 0,
            ancho: cotizacion.ancho || 0,
            profundidad: cotizacion.profundidad || 0,
            precio: cotizacion.precio || 0,
            porcentaje: cotizacion.porcentaje || 0,
            anticipo: cotizacion.anticipo || 0,
            saldo: cotizacion.saldo || 0,
            estado: cotizacion.estado || "Pendiente",
            cod_obra: cotizacion.cod_obra || 0,
         });
         fetchUser(cotizacion.usuario_id);
      }
   }, [cotizacion, fetchUser]);

   // Keyboard event handler
   useEffect(() => {
      const handleKeyDown = (e) => {
         if (e.key === "Escape") {
            handleClose();
         }
      };

      document.addEventListener("keydown", handleKeyDown);
      return () => document.removeEventListener("keydown", handleKeyDown);
   }, [handleClose]);

   const handleRespuesta = useCallback(async (respuesta) => {
      try {
         if (editRecord.precio === 0) {
            alert("Por favor ingrese un precio válido");
            return;
         }

         if (respuesta === "x") {
            if (editRecord.estado !== "pendiente") {
               respuesta = filterEstado;
            } else {
               respuesta = "cotizado";
            }
         }
         if (respuesta === "todos") {
            alert("Por favor seleccione un estado válido");
            return;
         }

         var codigoObra = 0;
         if (respuesta === "terminado") {
            var saldofinal = editRecord.precio;
            var detalleObra = editRecord.detalle;
            if (editRecord.porcentaje > 0) {
               saldofinal = Number(
                  editRecord.precio -
                     (editRecord.precio -
                        (editRecord.precio * editRecord.porcentaje) / 100)
               ).toLocaleString();
               detalleObra += ` - Anticipo recibido U$S ${
                  editRecord.precio - saldofinal
               } Porcentaje Anticipo ${editRecord.porcentaje}%`;
            }

            const obraData = {
               titulo: editRecord.titulo,
               descripcion: detalleObra,
               medidas: `${editRecord.alto} cm x ${editRecord.ancho} cm x ${editRecord.profundidad} cm`,
               filtros: ["6"],
               precio:
                  editRecord.precio -
                  (editRecord.precio -
                     (editRecord.precio -
                        (editRecord.precio * editRecord.porcentaje) / 100)),
               estado: 23,
            };
            const { data: obraResp, error: obraError } = await supabase
               .from("obras")
               .insert(obraData)
               .select("id")
               .single();

            if (obraError) {
               console.error("Error creating obra:", obraError);
               alert(`Error: ${obraError.message}`);
               return;
            }
            console.log("obraResp: ", obraResp);
            codigoObra = obraResp.id;

            console.log("✅ Obra creada exitosamente");
         }

         const { error } = await supabase
            .from("cotizacion")
            .update({
               precio: editRecord.precio,
               porcentaje: editRecord.porcentaje,
               anticipo: Number(
                  editRecord.precio -
                     (editRecord.precio -
                        (editRecord.precio * editRecord.porcentaje) / 100)
               ).toLocaleString(),
               saldo: Number(
                  editRecord.precio -
                     (editRecord.precio -
                        (editRecord.precio -
                           (editRecord.precio * editRecord.porcentaje) / 100))
               ).toLocaleString(),
               cod_obra: codigoObra,
               estado: respuesta,
            })
            .eq("id", editRecord.id);

         if (error) {
            console.error("Error updating cotización:", error);
            alert(`Error: ${error.message}`);
            return;
         }
         // Grabo Historial
         const { error: fetchError } = await supabase
            .from("cotizacion_hist")
            .insert({
               cotizacion_id: editRecord.id,
               estado: editRecord.estado,
            });

         if (fetchError) {
            console.error("Error inserting into cotizacion_hist:", fetchError);
            alert(`Error: ${fetchError.message}`);
            return;
         }

         const estadoTexto = estadoTexts[respuesta] || "actualizada";
         const emailData = {
            aquien: userRecord.email,
            reply_to: userRecord.email,
            asunto: `Actualización de su cotización #${editRecord.id}`,
            texto: `
            <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px; border: 1px solid #ddd; border-radius: 8px;">
               <h3 style="color: #333; margin: 0;">Cotización: ${estadoTexto}</h3>
               <p><strong>Detalles:</strong></p>
               <ul>
                  <li>Título: ${editRecord.titulo}</li>
                  <li>Estado: ${editRecord.estado}</li>
                  <li>Precio: U$S ${editRecord.precio.toLocaleString()}</li>
                  <li>Anticipo: % ${editRecord.porcentaje.toLocaleString()}</li>
                  <li>Saldo: U$S ${Number(
                     editRecord.precio -
                        (editRecord.precio -
                           (editRecord.precio -
                              (editRecord.precio * editRecord.porcentaje) /
                                 100))
                  ).toLocaleString()}</li>
               </ul>
               <p>Ingrese <a href="${
                  window.location.origin
               }">aquí</a> para ver los detalles completos.</p>
               <p>Gracias por su preferencia.</p>
            </div>
            `,
         };
         const resp = await Enviarmail(emailData);
         if (!resp) {
            console.log("resp: ", resp);
            console.error("Error enviando email de notificación");
         }

         console.log("✅ Cotización actualizada exitosamente");
      } catch (error) {
         console.error("Error in handleRespuesta:", error);
         alert("Error inesperado al guardar");
      }
      handleClose();
   }, [editRecord, filterEstado, userRecord.email, handleClose]);

   const handleSave = useCallback(async () => {
      try {
         if (!editRecord.titulo.trim()) {
            alert("Por favor ingrese un título");
            return;
         }

         if (editRecord.id === 0) {
            // New record - remove id from the record
            const { id, ...newRecord } = editRecord;

            const recordToInsert = {
               ...newRecord,
               usuario_id: userRecord.id,
               estado: "pendiente",
            };

            const { data: newdata, error } = await supabase
               .from("cotizacion")
               .insert(recordToInsert)
               .select()
               .single();

            if (error) {
               console.error("Error creating cotización:", error);
               alert(`Error: ${error.message}`);
               return;
            }
            // Grabo Historial
            const { error: fetchError } = await supabase
               .from("cotizacion_hist")
               .insert({
                  cotizacion_id: newdata.id,
                  estado: recordToInsert.estado,
               });

            if (fetchError) {
               console.error(
                  "Error inserting into cotizacion_hist:",
                  fetchError
               );
               alert(`Error: ${fetchError.message}`);
               return;
            }

            console.log("✅ Cotización creada exitosamente");
         } else {
            // Update existing record
            const updateData = {
               titulo: editRecord.titulo,
               detalle: editRecord.detalle,
               alto: editRecord.alto,
               ancho: editRecord.ancho,
               profundidad: editRecord.profundidad,
               precio: editRecord.precio,
               porcentaje: editRecord.porcentaje,
               saldo: editRecord.saldo,
               estado: editRecord.estado,
            };

            const { error } = await supabase
               .from("cotizacion")
               .update(updateData)
               .eq("id", editRecord.id);

            if (error) {
               console.error("Error updating cotización:", error);
               alert(`Error: ${error.message}`);
               return;
            }
            // Grabo Historial
            const { error: fetchError } = await supabase
               .from("cotizacion_hist")
               .insert({
                  cotizacion_id: editRecord.id,
                  estado: editRecord.estado,
               });

            if (fetchError) {
               console.error(
                  "Error inserting into cotizacion_hist:",
                  fetchError
               );
               alert(`Error: ${fetchError.message}`);
               return;
            }
            console.log("✅ Cotización actualizada exitosamente");
         }

         // Close modal after successful save
         handleClose();
      } catch (error) {
         console.error("Error in handleSave:", error);
         alert("Error inesperado al guardar");
      }
   }, [editRecord, userRecord.id, handleClose]);

   console.log("estados: ", estados);
   return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
         <div
            className="container mx-auto p-4 bg-white rounded-lg shadow-lg max-w-4xl relative z-10 max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
         >
            {/* Add close button in header */}
            <div className="flex justify-between items-center mb-4 pb-4 border-b">
               <h2 className="text-2xl ">
                  Cotización solicitada por : <b>{userRecord.nombre}</b>
               </h2>
               <button
                  onClick={handleClose}
                  className="text-gray-400 hover:text-gray-600 text-2xl transition-colors"
               >
                  <X className="w-6 h-6" />
               </button>
            </div>

            <div className="mt-4 rounded-lg border p-4 shadow-md bg-white">
               <div className="flex justify-between items-center mb-4">
                  <label className="block text-sm font-medium text-gray-700 p-2 w-48">
                     Título *
                  </label>
                  <input
                     className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                     value={editRecord.titulo || ""}
                     placeholder="Un título descriptivo de la obra"
                     onChange={(e) =>
                        setEditRecord({
                           ...editRecord,
                           titulo: e.target.value,
                        })
                     }
                     required
                  />
               </div>

               <div className="flex justify-between items-start mb-4">
                  <label className="block text-sm font-medium text-gray-700 p-2 w-48 mt-2">
                     Detalle de la obra
                  </label>
                  <textarea
                     className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                     rows={4}
                     value={editRecord.detalle || ""}
                     placeholder="Describe los detalles de la obra que deseas cotizar..."
                     onChange={(e) =>
                        setEditRecord({
                           ...editRecord,
                           detalle: e.target.value,
                        })
                     }
                  />
               </div>

               <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
                  <div className="flex flex-col">
                     <label className="block mb-2 text-sm font-medium text-gray-700">
                        Alto (cm)
                     </label>
                     <input
                        type="number"
                        className="p-2 border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        value={editRecord.alto || ""}
                        min="0"
                        step="0.1"
                        onChange={(e) =>
                           setEditRecord({
                              ...editRecord,
                              alto: parseFloat(e.target.value) || 0,
                           })
                        }
                     />
                  </div>
                  <div className="flex flex-col">
                     <label className="block mb-2 text-sm font-medium text-gray-700">
                        Ancho (cm)
                     </label>
                     <input
                        type="number"
                        className="p-2 border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        value={editRecord.ancho || ""}
                        min="0"
                        step="0.1"
                        onChange={(e) =>
                           setEditRecord({
                              ...editRecord,
                              ancho: parseFloat(e.target.value) || 0,
                           })
                        }
                     />
                  </div>
                  <div className="flex flex-col">
                     <label className="block mb-2 text-sm font-medium text-gray-700">
                        Profundidad (cm)
                     </label>
                     <input
                        type="number"
                        className="p-2 border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                        value={editRecord.profundidad || ""}
                        min="0"
                        step="0.1"
                        onChange={(e) =>
                           setEditRecord({
                              ...editRecord,
                              profundidad: parseFloat(e.target.value) || 0,
                           })
                        }
                     />
                  </div>
               </div>

               <div className="grid grid-cols-1 md:grid-cols-4 gap-4 p-4 bg-green-50 rounded-lg">
                  <div className="text-center">
                     <label className="block text-sm font-medium text-gray-700 mb-1">
                        Precio U$S
                     </label>
                     <input
                        type="text"
                        className="p-2 border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500  text-center"
                        value={editRecord.precio || ""}
                        onChange={(e) =>
                           setEditRecord({
                              ...editRecord,
                              precio: parseFloat(e.target.value) || 0,
                           })
                        }
                        disabled={editRecord.estado !== "pendiente"}
                     />
                  </div>
                  <div className="text-center">
                     <label className="block text-sm font-medium text-gray-700 mb-1">
                        % Anticipo Requerido
                     </label>
                     <input
                        type="text"
                        className="p-2 border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-center"
                        value={editRecord.porcentaje}
                        onChange={(e) =>
                           setEditRecord({
                              ...editRecord,
                              porcentaje: parseFloat(e.target.value) || 0,
                           })
                        }
                        disabled={editRecord.estado !== "pendiente"}
                     />
                  </div>
                  <div className="text-center">
                     <label className="block text-sm font-medium text-gray-700 mb-1">
                        Anticipo
                     </label>
                     <div className="text-1xl font-bold text-green-600">
                        U$S{" "}
                        {Number(
                           editRecord.precio -
                              (editRecord.precio -
                                 (editRecord.precio * editRecord.porcentaje) /
                                    100)
                        ).toLocaleString()}
                     </div>
                  </div>
                  <div className="text-center">
                     <label className="block text-sm font-medium text-gray-700 mb-1">
                        Saldo a pagar
                     </label>
                     <div className="text-1xl font-bold text-green-600">
                        U$S{" "}
                        {Number(
                           editRecord.precio -
                              (editRecord.precio -
                                 (editRecord.precio -
                                    (editRecord.precio *
                                       editRecord.porcentaje) /
                                       100))
                        ).toLocaleString()}
                     </div>
                  </div>
               </div>
            </div>

            <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
               {/* Filters */}
               {editRecord.estado !== "pendiente" && (
                  <div className="flex ">
                     <label className="block text-sm font-medium text-gray-700 mb-2 p-2">
                        Seleccione nuevo estado
                     </label>
                     <select
                        value={filterEstado}
                        onChange={(e) => setFilterEstado(e.target.value)}
                        className="border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                     >
                        <option value="todos">Seleccione..</option>
                        {Object.entries(estados).map(([key, config]) => (
                           <option key={key} value={key}>
                              {config.label}
                           </option>
                        ))}
                     </select>
                  </div>
               )}

               <button
                  onClick={handleClose}
                  className="btn-gray-light flex items-center gap-2"
               >
                  <ArrowLeft className="w-4 h-4" /> Volver
               </button>
               {editRecord.precio === 0 && (
                  <button
                     onClick={handleSave}
                     disabled={!editRecord.titulo.trim()}
                     className="btn-green flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                  >
                     <Plus className="w-4 h-4" />
                     {editRecord.id === 0 ? "Crear Cotización" : "Actualizar"}
                  </button>
               )}
               {editRecord.precio !== 0 && (
                  <>
                     <button
                        onClick={() => handleRespuesta("anulado")}
                        disabled={!editRecord.titulo.trim()}
                        className="btn-red flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                     >
                        <CircleX className="w-4 h-4" />
                        Anular Cotización
                     </button>
                     <button
                        onClick={() => handleRespuesta("x")}
                        disabled={!editRecord.titulo.trim()}
                        className="btn-green flex items-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
                     >
                        <Check className="w-4 h-4" />
                        Aceptar
                     </button>
                  </>
               )}
            </div>
         </div>

         {/* Click outside to close */}
         <div className="absolute inset-0 -z-10" onClick={handleClose} />
      </div>
   );
};

export default CotizacionModal;
